import { db, auth } from '../firebase';
import { collection, addDoc, serverTimestamp, updateDoc, doc } from 'firebase/firestore';

export const logActivity = async (action, description, additionalData = {}) => {
  try {
    const user = auth.currentUser;
    if (!user) return;

    // Create the activity log in admin_activity_logs collection
    const logsRef = collection(db, 'admin_activity_logs');
    await addDoc(logsRef, {
      userId: user.uid,
      userEmail: user.email,
      action,
      description,
      ...additionalData,
      timestamp: serverTimestamp()
    });

    // Update the user's last activity timestamp
    const userRef = doc(db, 'users', user.uid);
    await updateDoc(userRef, {
      lastActivity: serverTimestamp()
    });
  } catch (error) {
    console.error('Error logging activity:', error);
  }
};

// Specific logging functions for different actions
export const logLogin = async () => {
  // Only log login if it's a fresh login (not a page refresh)
  const lastLogin = localStorage.getItem('lastLogin');
  const now = new Date().getTime();

  // Device type detection
  let deviceType = 'desktop';
  const ua = navigator.userAgent;
  if (/Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
    deviceType = /Tablet|iPad/i.test(ua) ? 'tablet' : 'mobile';
  }

  if (!lastLogin || (now - parseInt(lastLogin)) > 1000 * 60 * 5) { // 5 minutes
    await logActivity('login', 'User logged in', { deviceType });
    localStorage.setItem('lastLogin', now.toString());
  }
};

export const logCreativeApproval = async (creativeId, creativeName) => {
  await logActivity(
    'creative_approval',
    `Approved creative: ${creativeName}`,
    { creativeId }
  );
};

export const logCreativeRejection = async (creativeId, creativeName, reason) => {
  await logActivity(
    'creative_rejection',
    `Rejected creative: ${creativeName}`,
    { creativeId, reason }
  );
};

export const logCampaignApproval = async (campaignId, campaignName) => {
  await logActivity(
    'campaign_approval',
    `Approved campaign: ${campaignName}`,
    { campaignId }
  );
};

export const logCampaignRejection = async (campaignId, campaignName, reason) => {
  await logActivity(
    'campaign_rejection',
    `Rejected campaign: ${campaignName}`,
    { campaignId, reason }
  );
};

export const logTakeoverApproval = async (takeoverId, takeoverName) => {
  await logActivity(
    'takeover_approval',
    `Approved takeover: ${takeoverName}`,
    { takeoverId }
  );
};

export const logTakeoverRejection = async (takeoverId, takeoverName, reason) => {
  await logActivity(
    'takeover_rejection',
    `Rejected takeover: ${takeoverName}`,
    { takeoverId, reason }
  );
};

export const logUserUpdate = async (updatedFields) => {
  await logActivity(
    'user_update',
    'Updated user information',
    { updatedFields }
  );
};

export const logFileUpload = async (fileName, fileType) => {
  await logActivity(
    'file_upload',
    `Uploaded ${fileType}: ${fileName}`,
    { fileName, fileType }
  );
}; 